import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';

@Component({
  selector: 'app-qrcode-group',
  templateUrl: './qrcode-group.page.html',
  styleUrls: ['./qrcode-group.page.scss'],
})
export class QrcodeGroupPage implements OnInit {
  @Input() url: any;
  @Input() name: any;
  _type:any="";//判断类型
  constructor(
    public modalController: ModalController,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
  ) { }

  ngOnInit() {
  }
   // 取消
   dismissModal() {
    const that=this;
    let _array:Array<any> = new Array<any>();
    this.modalController.dismiss({
      "modalStatus": false,
      "type":that._type,
      "info": '0'
    });
  }
  // 确定
  comfireModal() {
    const that=this;
    that.modalController.dismiss({
      "modalStatus":true,
      "type":that._type,
      "info": "是的"
    });
  }
}
